module.exports = __webpack_public_path__ + "static/media/steve-grand-canyon-guitar.cc157a4b.jpg";